import { FC, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { isNewLearnerMF } from '@/features/learnerMF/isNewLearnerMF'
import { useLazyGetObjectiveAccessByIdQuery } from '@/store/api/aggregatesApi'
import { useAppDispatch } from '@/store/hooks'
import { addBlockingOperation, removeBlockingOperation } from '@/store/slices/loadingSlice'
import CourseDetails from './CourseDetails/CourseDetails'
import CourseDetailsMF from './CourseDetails/CourseDetailsMF'

type CourseDetailsPrefetcherProps = {
  onError: VoidFunction
}

export const CourseDetailsPrefetcher: FC<CourseDetailsPrefetcherProps> = ({ onError }) => {
  const dispatch = useAppDispatch()

  const { objectiveId = '' } = useParams()

  const [getObjectiveAccessByIdQuery] = useLazyGetObjectiveAccessByIdQuery()

  useEffect(() => {
    dispatch(addBlockingOperation())

    getObjectiveAccessByIdQuery(objectiveId)
      .unwrap()
      .then((aggregate) => {
        if (!aggregate) {
          onError()
        }
      })
      .catch((error) => {
        if ([400, 401, 403, 404].includes(error.status)) {
          onError()
        }
      })
      .finally(() => {
        dispatch(removeBlockingOperation())
      })
  }, [dispatch, getObjectiveAccessByIdQuery, onError, objectiveId])

  return isNewLearnerMF() ? <CourseDetailsMF /> : <CourseDetails onError={onError} />
}
